import type { LandingContent } from '../content/landingContentTypes.js';
import { isRetailIndustryPageKey } from '../content/retailIndustryLabels.js';

/** Append only the newly introduced retail links; existing editor order and omissions stay intact. */
export const backfillRetailIndustryNavigation = (content: LandingContent, defaults: LandingContent): void => {
  const links = content.industryNav ??= [];
  for (const item of defaults.industryNav ?? []) {
    const key = item.href.match(/^\/branchen\/([^/?#]+)/u)?.[1] ?? '';
    if (isRetailIndustryPageKey(key) && !links.some(link => link.href === item.href)) links.push({ ...item });
  }
};
